import { OrderPaymentCheckCreationDto } from '../dtos/order-payment-check.dto';
import { OrderPaymentCheckCreation } from '../models/order-payment-check';

/**
 * Map order payment check creation to dto.
 * @param {OrderPaymentCheckCreation} model Model.
 * @returns {OrderPaymentCheckCreationDto}
 */
function toCreationDto(model) {
  return {
    name: model.checkName,
    number: model.checkNumber,
    amount: model.amount,
  };
}

export const orderPaymentCheckMapper = {
  toCreationDto,
};
